var map = {
	"./arrow_down.svg": "918b",
	"./arrow_left.svg": "b50a",
	"./checkmark.svg": "5f63",
	"./close.svg": "6282",
	"./document.svg": "cce3",
	"./group.svg": "569b",
	"./key.svg": "d769",
	"./loading.svg": "e2607",
	"./moon.svg": "3afe",
	"./more.svg": "f4fc",
	"./new_file.svg": "8f40",
	"./new_folder.svg": "8831",
	"./pensil.svg": "f04a",
	"./plus.svg": "8c7a",
	"./sun.svg": "360c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "909e";